import { createReducer } from '@reduxjs/toolkit';

import { postLogout } from '@perpay-web/fintech/actions/authentication';

export default createReducer({}, (builder) => {
    // destroy all app state on logout
    builder.addCase(postLogout, () => ({}));
});
